module.exports = __webpack_public_path__ + "operace-ocnich-vicek-dolni_4_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/operace-ocnich-vicek-dolni_4_before_tn.jpg
// module id = 1620
// module chunks = 0